import { render, staticRenderFns } from "./FolderList.vue?vue&type=template&id=71f9edf2"
import script from "./FolderList.ts?vue&type=script&lang=ts&external"
export * from "./FolderList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports